<nav class="relative z-50 " aria-label="Language selection">
  <button mat-icon-button type="button" [matMenuTriggerFor]="languageMenu" aria-label="Select language" class="">
    <dsr-flag [country]="languages[currentLanguageIndex].flag" [size]="triggerSize"></dsr-flag>
  </button>

  <mat-menu #languageMenu="matMenu" class="language-menu">

    @for (language of languages; track language; let i = $index) {
      <button mat-menu-item type="button"
        class=""
        (click)="changeLanguage(i)" [attr.aria-label]="'Select ' + language.name">
        <div class="flex justify-between">
          <div class="!w-fit">
            <dsr-flag aria-hidden="true" [country]="language.flag" [size]="itemFlagSize"></dsr-flag>
          </div>
          <span class="inline-block !w-full text-start dsr-typescale-label-medium" [class.!uppercase]="uppercase">
            {{ displayProperty === 'name' ? language.name : language.code }}
          </span>
        </div>
      </button>
    }
  </mat-menu>
</nav>